export default __webpack_public_path__ + "static/media/classes2.077baf8e.svg";